import { render } from "./EditValidationRule.vue?vue&type=template&id=ef283f08"
import script from "./EditValidationRule.vue?vue&type=script&lang=js"
export * from "./EditValidationRule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__